<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="text">推送配置列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small">新增规则</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增推送配置' : '编辑推送配置'"
      footer-hide
      width="700"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="名称" prop="name">
              <Input v-model="item.name" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="是否启用" prop="enabled">
              <i-switch v-model="item.enabled">
                <span slot="open">{{$t('bool.true')}}</span>
                <span slot="close">{{$t('bool.false')}}</span>
              </i-switch>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="推送邮箱" prop="mailList">
              <add-item v-model="item.mailList"></add-item>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="推送电话" prop="telList">
              <add-item v-model="item.telList"></add-item>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="报警列表" prop="alarmList">
              <Select v-model="item.alarmList" multiple>
                <Option
                  v-for="x in alarmTypeList"
                  :value="x.name"
                  :key="x.name"
                  >{{ x.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="通知列表" prop="noticeList">
              <Select v-model="item.noticeList" multiple>
                <Option
                  v-for="x in noticeTypeList"
                  :value="x.name"
                  :key="x.name"
                  >{{ x.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="备注" prop="remark">
              <Input
                v-model="item.remark"
                type="textarea"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import addItem from "../common/addItem.vue";
export default {
  components: { addItem },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "类型名称",
          key: "name",
        },
        {
          title: "报警",
          key: "alarm",
        },
        {
          title: "分数",
          key: "score",
        },
        {
          title: "是否启用",
          key: "enabled",
          render: (h, data) => {
            return h("div", this.$t("bool." + data.row.enabled));
          },
        },
        {
          title: "备注",
          key: "remark",
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        enabled: true,
        name: "",
        alarmList: [],
        mailList: [],
        noticeList: [],
        remark: "",
        telList: [],
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      alarmTypeList:[],
      noticeTypeList:[]
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/push/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.rule + "/push/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.rule + "/push/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.rule + "/push/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    getAlarmType() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "alarmType",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.alarmTypeList = JSON.parse(res.data.data.value);
      });
    },
    getNoticeType() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "noticeType",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.noticeTypeList = JSON.parse(res.data.data.value);
      });
    },
  },
  mounted() {
    this.getList();
    this.getAlarmType();
    this.getNoticeType();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/rule/ruleNotice.vue